import React, { useContext } from 'react'
import { Helmet } from 'react-helmet-async'
import { useParams } from 'react-router-dom'
import { Content, Indicators, Layout, Navigation, Responsive } from 'ui'
import { AvatarEditor } from '../../AppNavigator/Settings/AvatarEditor'
import { ProfileEditView } from '../../AppNavigator/Settings/ProfileEditView'
import { usePaginatedProfiles } from './usePaginatedProfiles'
import { UserProfileNavigationDrawer } from './UserProfileNavigationDrawer'
import { useAdminProfileById } from '../../../queries/useAdminProfileById'

export const UserProfileEditView: React.FC = () => {
  // Drawer appearance
  const { useDisplayMode } = useContext(Responsive.DrawerManagerContext)
  useDisplayMode('compact')

  const { id } = useParams<{ id: string }>()
  const { locationSearch } = usePaginatedProfiles()
  const {
    data: profile,
    isLoading: loading,
    error: profileError,
  } = useAdminProfileById(id)

  return (
    <div
      className="w-full flex flex-grow flex-col flex sm:flex-row flex bg-contentareabackgroundalt"
      style={{ opacity: loading ? 0.5 : 1 }}
    >
      <Helmet>
        <title>
          Editing{' '}
          {profile?.lastName
            ? `${profile?.firstName} ${profile?.lastName}`
            : 'Profile'}{' '}
          - MCSS Pro Connect
        </title>
      </Helmet>
      <UserProfileNavigationDrawer />
      <Layout.PaddedContent className="overflow-y-auto">
        <div className="flex-col flex md:flex-row flex">
          <div className="mr-0 sm:mr-4 w-full flex-col flex">
            <Content.Body>
              <Navigation.ReturnLink
                to={`/admin/profiles/show/${id}${locationSearch}`}
              >
                Return to Profile
              </Navigation.ReturnLink>
            </Content.Body>
            <Content.Heading>
              {loading ? (
                <div>
                  <div className="mr-auto">
                    <Indicators.Spinner />
                  </div>
                </div>
              ) : (
                `${profile?.firstName} ${profile?.lastName}`
              )}
            </Content.Heading>
            {profile ? (
              <ProfileEditView
                loading={loading}
                profile={profile}
                profileId={id}
              />
            ) : null}
          </div>

          <div className="flex flex-col flex mt-2 md:mt-4 mb-auto w-full sm:w-1/2 md:w-1/3">
            <AvatarEditor loading={loading} profile={profile} profileId={id} />
          </div>
        </div>
      </Layout.PaddedContent>
    </div>
  )
}
